"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _helpers = require("./helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MediaObject = function MediaObject(_ref) {
  var type = _ref.type,
    src = _ref.src,
    alt = _ref.alt,
    readOnly = _ref.readOnly,
    imageFallback = _ref.imageFallback,
    recommendedMediaSizes = _ref.recommendedMediaSizes;
  var isImage = type === _config.MEDIA_TYPE.IMAGE;
  var mediaObject;
  if (isImage) {
    mediaObject = /*#__PURE__*/_react["default"].createElement("img", {
      src: src,
      alt: alt || 'Banner image',
      onError: function onError(e) {
        e.target.onerror = null;
        e.target.src = imageFallback;
      },
      className: "media-image media",
      title: alt
    });
    mediaObject = readOnly ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "media"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: src,
      target: "_blank",
      rel: "noopener noreferrer"
    }, mediaObject)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-wrapper media"
    }, mediaObject);
  } else {
    mediaObject = /*#__PURE__*/_react["default"].createElement("iframe", {
      height: _utils.isMobile ? _helpers.RECOMMENDED_MOBILE_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].height : R.prop('height', recommendedMediaSizes) || _helpers.RECOMMENDED_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].height,
      width: _utils.isMobile ? _helpers.RECOMMENDED_MOBILE_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].width : R.prop('width', recommendedMediaSizes) || _helpers.RECOMMENDED_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].height,
      src: (0, _helpers.transformUrl)(src),
      title: alt || 'Video-Title',
      frameBorder: "0"
    });
  }
  return mediaObject;
};
MediaObject.defaultProps = {
  type: _config.MEDIA_TYPE.IMAGE,
  src: '',
  alt: '',
  readOnly: false,
  imageFallback: null,
  recommendedMediaSizes: {}
};
MediaObject.propTypes = {
  type: _propTypes["default"].string,
  src: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  recommendedMediaSizes: _propTypes["default"].shape({})
};
var _default = MediaObject;
exports["default"] = _default;